import VisualizeSessionTypes from '../components/course/visualize-session-types';
<template><VisualizeSessionTypes @model={{@model}} /></template>
